import { MODULES_CATALOG } from "@nxvolt/shared";

const PHASE_HINTS: Record<string, string> = {
  dashboard: "Cards de KPI + gráficos em tempo real (Fase 4).",
  chargers: "Lista, cadastro, status ao vivo e comandos remotos (Fase 5).",
  sessions: "Histórico de transações, filtros e exportação CSV (Fase 6).",
  alerts: "Alertas e reconhecimento (fase posterior).",
  users: "Gestão de usuários e reset de senha (fase posterior).",
  settings: "Configurações do sistema e integrações (fase posterior).",
};

/**
 * Fallback para slugs sem página real. Herda o cabeçalho padrão para não
 * quebrar o padrão visual do resto do app: quem cair aqui vê categoria,
 * nome do módulo e razão em uma frase.
 */
export function ModulePlaceholder({ slug }: { slug: string }) {
  const def = MODULES_CATALOG.find((m) => m.slug === slug);
  const hint = PHASE_HINTS[slug] ?? "Este módulo ainda não está implementado.";
  return (
    <div>
      <div className="nx-page-head">
        <div className="nx-page-head__title">
          <span className="nx-page-head__eyebrow">Módulo</span>
          <h1>{def?.name ?? slug}</h1>
          <div className="nx-page-head__sub">{hint}</div>
        </div>
        <div className="nx-page-head__actions">
          <span className="nx-pill">Em construção</span>
        </div>
      </div>
      <div className="nx-card">
        <p style={{ color: "var(--nx-mute)", margin: 0 }}>
          Esta tela é um espaço reservado. O conteúdo entra quando o módulo
          <b> {def?.name ?? slug}</b> estiver pronto.
        </p>
      </div>
    </div>
  );
}
